import React, { Component } from "react";
import { Button, Form, InputGroup, Modal } from "react-bootstrap";
import VechiclesApi from "../../api/VechiclesApi";
import AuthService from "../../session/AuthService";

import EnlargeImage from "../../customFunctions/EnlargeImage";
import getBaseUrl from "../../customFunctions/getBaseUrl";
import DatePicker from "react-multi-date-picker";
import moment from "moment";
import { API_URL } from "../../config/app-config";

class CreateVehicles extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formValues: {
        vehicleImage: null,
      },
      colorChange: false,
    };
  }

  componentDidMount = () => {
    console.log("option in create data in vechiclaees", this.props);
    if (
      this.props.editValue &&
      Object.keys(this.props.editValue).length > 0 &&
      this.props.option === "edit"
    ) {
      this.setState(
        {
          formValues: {
            ...this.props.editValue,
            expiryDate: this.props.editValue?.expiryDate ? moment(this.props.editValue?.expiryDate).format("DD/MM/YYYY") : null, // Updates expiryDate to current date in ISO format
          },
      
          colorChange: true,
        },
        () => {
          console.log(this.state.formValues, "after set");
        }
      );
    }
  };

  render() {
    const { formValues, colorChange } = this.state;
    return (
      <>
        <Modal
          show={this.props.show}
          onHide={this.props.handleClose}
          backdrop="static"
        >
          <Modal.Header closeButton>
            <h5 style={{ fontWeight: "bolder" }}>
              {this.props.option === "edit" ? "Edit Vehicle" : "Add Vehicle"}
            </h5>
          </Modal.Header>
          <Modal.Body>
            <Form.Group className="mb-1" controlId="exampleForm.ControlInput1">
              <Form.Label>Name</Form.Label>
              <Form.Control
                type="text"
                // placeholder="Name"
                autoFocus
                className="small-input"
                name="vehicle_name"
                onChange={this.OnHandleChange}
                value={formValues.vehicle_name}
                readOnly={AuthService.getUserTypeAdmin() === "3"}
              />
            </Form.Group>
            <Form.Group className="mb-1" controlId="exampleForm.ControlInput1">
              <Form.Label>Model</Form.Label>
              <Form.Control
                type="text"
                // placeholder="Model"
                autoFocus
                className="small-input"
                name="vehicle_model"
                onChange={this.OnHandleChange}
                value={formValues.vehicle_model}
                readOnly={AuthService.getUserTypeAdmin() === "3"}
              />
            </Form.Group>

            <div class="form-group" style={{ marginBottom: "10px" }}>
              <label
                for="exampleFormControlTextarea1"
                style={{ fontSize: "14px", fontWeight: 500 }}
              >
                Description
              </label>
              <textarea
                class="form-control"
                id="exampleFormControlTextarea1"
                rows="3"
                name="vehicle_desc"
                onChange={this.OnHandleChange}
                value={formValues.vehicle_desc}
                style={{ backgroundColor: "#F3F4F1", borderColor: "#F3F4F1" }}
                readOnly={AuthService.getUserTypeAdmin() === "3"}
              ></textarea>
            </div>

            <div className="Border-line"></div>

            <div className="row">
              <div className="col-3">
                <Form.Group
                  className="mb-1"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>Year</Form.Label>
                  <Form.Control
                    type="number"
                    // placeholder="Year"
                    autoFocus
                    className="small-input"
                    name="year"
                    onChange={this.OnHandleChange}
                    value={formValues.year}
                    onInput={(e) => {
                      e.target.value = e.target.value
                        .replace(/[^0-9]/g, "")
                        .slice(0, 4);
                    }}
                    onPaste={(e) => {
                      const pastedText = e.clipboardData.getData("text/plain");
                      const pastedNumbers = pastedText
                        .replace(/[^0-9]/g, "")
                        .slice(0, 4);
                      e.preventDefault();
                      document.execCommand("insertText", false, pastedNumbers);
                    }}
                    readOnly={AuthService.getUserTypeAdmin() === "3"}
                  />
                </Form.Group>
              </div>
              <div className="col-9">
                <Form.Group
                  className="mb-1"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>S/N</Form.Label>
                  <Form.Control
                    type="text"
                    // placeholder="S/N"
                    autoFocus
                    className="small-input"
                    name="serialnumber"
                    onChange={this.OnHandleChange}
                    value={formValues.serialnumber}
                    readOnly={AuthService.getUserTypeAdmin() === "3"}
                  />
                </Form.Group>
              </div>
            </div>
            <div className="row">
              <div className="col">
                <Form.Group
                  className="mb-1"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>Year Acquired</Form.Label>
                  <Form.Control
                    type="text"
                    // placeholder="Year Acquired"
                    autoFocus
                    className="small-input"
                    name="year_acquired"
                    onChange={this.OnHandleChange}
                    value={formValues.year_acquired}
                    readOnly={AuthService.getUserTypeAdmin() === "3"}
                  />
                </Form.Group>
              </div>
              <div className="col">
                <Form.Group
                  className="mb-1"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>Plate Number</Form.Label>
                  <Form.Control
                    type="text"
                    // placeholder="Plate Number"
                    autoFocus
                    className="small-input"
                    name="plateNumber"
                    onChange={this.OnHandleChange}
                    value={formValues.plateNumber}
                    readOnly={AuthService.getUserTypeAdmin() === "3"}
                  />
                </Form.Group>
              </div>
            </div>
            <div className="row">
              <div>
                <Form.Group
                  className="mb-2"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>Choose Safety Expiry Date</Form.Label>
                  <InputGroup>
                    <DatePicker
                      disabled={AuthService.getUserTypeAdmin() === "3"}
                      format="DD/MM/YYYY"
                      minDate={new Date()}
                      placeholder="DD/MM/YYYY"
                      value={formValues.expiryDate}
                      name="expiryDate"
                      onChange={(value) => this.handleDateChange(value)}
                      style={{
                        height: "35px",
                        backgroundColor: "#F3F4F1",
                        borderColor: "#F3F4F1",
                      }}
                    />
                    <InputGroup.Append>
                      <i
                        className="fa fa-calendar"
                        style={{
                          position: "absolute",
                          left: "15rem",
                          top: "10px",
                          color: "rgb(138, 188, 73)",
                        }}
                      ></i>
                    </InputGroup.Append>
                  </InputGroup>
                </Form.Group>
              </div>
            </div>
            <div className="row">
              <Form.Group
                className="mb-1"
                controlId="exampleForm.ControlInput1"
              >
                <Form.Label>Policy Number</Form.Label>
                <Form.Control
                  type="text"
                  // placeholder="Year Acquired"
                  autoFocus
                  className="small-input"
                  name="policyNumber"
                  onChange={this.OnHandleChange}
                  value={formValues.policyNumber}
                  readOnly={AuthService.getUserTypeAdmin() === "3"}
                />
              </Form.Group>
            </div>

            <div class="form-group" style={{ marginBottom: "10px" }}>
              <label
                for="exampleFormControlTextarea1"
                style={{ fontSize: "14px", fontWeight: 500 }}
              >
                Oil type and capacities
              </label>
              <textarea
                class="form-control"
                id="exampleFormControlTextarea1"
                rows="3"
                name="oilType"
                onChange={this.OnHandleChange}
                value={formValues.oilType}
                style={{ backgroundColor: "#F3F4F1", borderColor: "#F3F4F1" }}
                readOnly={AuthService.getUserTypeAdmin() === "3"}
              ></textarea>
            </div>
            <div class="form-group" style={{ marginBottom: "10px" }}>
              <label
                for="exampleFormControlTextarea1"
                style={{ fontSize: "14px", fontWeight: 500 }}
              >
                Filter and Parts Numbers
              </label>
              <textarea
                class="form-control"
                id="exampleFormControlTextarea1"
                rows="3"
                name="filterParts"
                onChange={this.OnHandleChange}
                value={formValues.filterParts}
                style={{ backgroundColor: "#F3F4F1", borderColor: "#F3F4F1" }}
                readOnly={AuthService.getUserTypeAdmin() === "3"}
              ></textarea>
            </div>

            <div className="row">
              <div className="col">
                <Form.Group
                  className="mb-2"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>Time Service Interval with Activity</Form.Label>
                  <select
                    className="form-select form-select-sm"
                    aria-label=".form-select-sm example"
                    id="form-select-sm-employee"
                    name="service_interval"
                    onChange={this.OnHandleChange}
                    value={formValues.service_interval}
                    style={{ color: colorChange ? "black" : "#747c84" }}
                    disabled={AuthService.getUserTypeAdmin() === "3"}
                  >
                    <option selected>Select</option>
                    <option value="semi">Semi</option>
                    <option value="quarterly">Quarterly</option>
                    <option value="monthly">Monthly</option>
                    <option value="yearly">Yearly</option>
                  </select>
                </Form.Group>
              </div>
              <div className="col">
                <div className="checkbox-wrapper-22">
                  <label htmlFor="checkbox">Active Registration</label>
                  <label className="switch" htmlFor="checkbox">
                    <input
                      type="checkbox"
                      name={"activeRegistration"}
                      checked={formValues.activeRegistration}
                      id="checkbox"
                      onChange={this.handleCheckboxChange}
                    />
                    <span className="slider round"></span>
                  </label>
                </div>
              </div>
            </div>

            <div class="form-group" style={{ marginBottom: "10px" }}>
              <label
                for="exampleFormControlTextarea1"
                style={{ fontSize: "14px", fontWeight: 500 }}
              >
                Notes
              </label>
              <textarea
                class="form-control"
                id="exampleFormControlTextarea1"
                rows="3"
                name="notes"
                onChange={this.OnHandleChange}
                value={formValues.notes}
                style={{ backgroundColor: "#F3F4F1", borderColor: "#F3F4F1" }}
                readOnly={AuthService.getUserTypeAdmin() === "3"}
              ></textarea>
            </div>
            <Form.Group className="mb-3" controlId="formBasicNo">
              <Form.Label></Form.Label>
              <br />
              <div className="custom-file">
                {this.state.formValues.resourceImage ? (
                  <label htmlFor="customFile" className="file-label">
                    {this.state.formValues.resourceImage.name}
                  </label>
                ) : (
                  <label htmlFor="customFile" className="file-label">
                    {this.props.option === "edit" &&
                    this.props.editValue.orginalImageName !== null
                      ? this.props.editValue.orginalImageName
                      : "Click to Upload File"}
                  </label>
                )}
                <input
                  type="file"
                  id="customFile"
                  onChange={this.handlefile}
                  name="resourceImage"
                  accept="image/*"
                  multiple={false}
                  disabled={AuthService.getUserTypeAdmin() === "3"}
                />
              </div>
            </Form.Group>

            <div className="Image-perview-container">
              {this.props.option === "edit" &&
              this.state.formValues.vehicleImage !== null ? (
                <div className="image-preview" onClick={this.handleAvatarClick}>
                  {this.state.formValues.resourceImage instanceof Blob ? (
                    <img
                      src={URL.createObjectURL(
                        this.state.formValues.resourceImage
                      )}
                      alt="Overlay"
                      className="preview-image"
                    />
                  ) : (
                    <img
                      src={`${API_URL}auth/assets/${this.state.formValues.vehicleImage}`}
                      alt="Preview"
                      className="preview-image"
                    />
                  )}
                  {/* <div className="close-icon" onClick={this.handleClearImage}>
                    <FontAwesomeIcon
                      icon={faTrash}
                      style={{ color: "rgb(138, 188, 73)" }}
                    />
                  </div> */}
                </div>
              ) : (
                <div className="image-preview" onClick={this.handleAvatarClick}>
                  {this.state.formValues.resourceImage instanceof Blob && (
                    <>
                      <img
                        src={URL.createObjectURL(
                          this.state.formValues.resourceImage
                        )}
                        alt="Preview"
                        className="preview-image"
                      />

                      {/* <div
                        className="close-icon"
                        onClick={this.handleClearImage}
                      >
                        <FontAwesomeIcon
                          icon={faTrash}
                          style={{ color: "rgb(138, 188, 73)" }}
                        />
                      </div> */}
                    </>
                  )}
                </div>
              )}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.props.handleClose}>
              Cancel
            </Button>
            <Button variant="success" type="button" onClick={this.saveForm}>
              {this.props.option === "edit" ? "Edit Vehicle" : "Add Vehicle"}
            </Button>
          </Modal.Footer>
        </Modal>
        {this.state.isModalOpen && (
          <EnlargeImage
            onClose={this.handleAvatarClick}
            imageUrl={
              this.props.option === "edit" &&
              this.state.formValues.resourceImage
                ? URL.createObjectURL(this.state.formValues.resourceImage)
                : this.props.option === "edit" &&
                  this.state.formValues.vehicleImage !== null
                ? `${API_URL}auth/assets/${
                    this.state.formValues.vehicleImage
                  }`
                : URL.createObjectURL(this.state.formValues.resourceImage)
            }
          />
        )}
      </>
    );
  }

  handleCheckboxChange = (event) => {
    var isChecked = event.target.checked;

    let form = this.state.formValues;
    form["activeRegistration"] = isChecked;

    this.setState({
      formValues: form,
    });
  };

  handleAvatarClick = () => {
    this.setState({
      isModalOpen: !this.state.isModalOpen,
    });
  };

  handlefile = (event) => {
    const file = event.target.files[0];
    console.log("file", file);
    let form = { ...this.state.formValues };
    form[event.target.name] = file;
    this.setState({
      formValues: form,
    });
  };

  OnHandleChange = (event) => {
    let form = { ...this.state.formValues };

    if (event.target.name === "year") {
      console.log("inside the year");
      // Remove non-numeric characters
      const numericValue = event.target.value.replace(/\D/g, "");

      // Limit the input to 4 digits
      const truncatedValue = numericValue.slice(0, 4);

      form[event.target.name] = truncatedValue;
    } else {
      console.log("outside the year");
      form[event.target.name] = event.target.value;
    }

    if (event.target.name === "service_interval") {
      this.setState({
        formValues: form,
        colorChange: true, // Set colorChange to true when equipmentTimeService changes
      });
    } else {
      this.setState({
        formValues: form,
      });
    }
  };


  handleDateChange = (date) => {
    if (date === null) {
      console.log("dateChanged: null");
    } else if (date instanceof Date) {
      console.log("dateChanged:", date.toString());
    } else {
      console.log("dateChanged: invalid or unexpected value", date);
    }
  
    let form = this.state.formValues || {};
    form["expiryDate"] = date ? date.toString() : null;
  
    this.setState({ formValues: form }, () => {
      console.log("date", form["expiryDate"]);
    });
  };
  

  // handleDateChange = (date) => {

  //   console.log("dateChanged", date.toString());
  //   if (date) {

  //     let form = this.state.formValues || {}; 

  //     form["expiryDate"] = date.toString();
  //     this.setState(
  //       {
  //         formValues: form,
  //       },
  //       () => {
  //         console.log("date", date.toString());
  //       }
  //     );
  //   }
  // };

  saveForm = () => {
    console.log("formvalues", this.state.formValues);
    if (this.props.option === "edit") {
      if (!this.state.formValues.vehicle_name) {
        this.props.errorToast("Please Enter Vehicle Name");
      } else if (!this.state.formValues.vehicle_model) {
        this.props.errorToast("Please Enter Vehicle Model");
      } else if (!this.state.formValues.service_interval) {
        this.props.errorToast("Please Enter Time Service Interval");
      } else {
        let form = new FormData(); // Create FormData instance

        // Append each key-value pair from formValues to FormData
        const keysToInclude = [
          "vehicle_id",
          "vehicle_name",
          "vehicle_model",
          "year",
          "year_acquired",
          "service_interval",
          "status_of_vechicle",
          "vehicle_desc",
          "plateNumber",
          "serialnumber",
          "vehicleImage",
          "policyNumber",
          "activeRegistration",
          "expiryDate",
          "notes",
          "oilType",
          "filterParts"
        ];

        // Append only the specified keys from formValues to FormData
        keysToInclude.forEach((key) => {
          if (key === "expiryDate") {
            console.log("Expiry Date", this.state.formValues[key]);
            if(this.state.formValues[key]){
              form.append(key, moment.parseZone(this.state.formValues[key], "DD/MM/YYYY"));
            }
          } else {
            form.append(key, this.state.formValues[key]);
          }
        });

        if (this.state.formValues.resourceImage?.name) {
          form.append("resourceImage", this.state.formValues.resourceImage);
        }

        form.append("group_id", parseInt(AuthService.getUserId()));

        VechiclesApi.editVehicle(form).then((response) => {
          if (response.data && response.data.message === "success") {
            this.props.handleClose();
            this.props.pageLoad();
            this.props.renderToast("Edit");
          }
        });
      }
    } else {
      if (!this.state.formValues.vehicle_name) {
        this.props.errorToast("Please Enter Vehicle Name");
      } else if (!this.state.formValues.vehicle_model) {
        this.props.errorToast("Please Enter Vehicle Model");
      } else if (!this.state.formValues.service_interval) {
        this.props.errorToast("Please Enter Time Service Interval");
      } else {
        let form = new FormData(); // Create FormData instance

        // Append each key-value pair from formValues to FormData
        for (const key in this.state.formValues) {
          console.log("key", key, this.state.formValues[key]);
          if (key === "expiryDate") {
            if(this.state.formValues[key]){
              form.append(key, moment.parseZone(this.state.formValues[key], "DD/MM/YYYY"));
            }
          } else {
            form.append(key, this.state.formValues[key]);
          }
        }

        form.append("group_id", parseInt(AuthService.getUserId()));

        console.log("formdata", form);

        VechiclesApi.saveVehicle(form).then((response) => {
          console.log("response of the vehicles", response);
          if (response.data && response.data.message === "success") {
            this.props.handleClose();
            this.props.onLoad();
            this.props.renderToast("Create");
          }
        });
      }
    }
  };
}
export default CreateVehicles;
